module.exports = __webpack_public_path__ + "img/icon-footer-tel.402f3d7e.svg";